<template>
  <!-- Total: 1+4+5+5+6+3+3+8+1 = 36 spans -->
  <div>
    <div class="cardLayoutWrapper">
      <BasicCellActionIcon
        :span="1"
        icon-name="danger"
        :deactivated="!item?.avecAlerteActionAFaire"
        :hover-messages="{ actif: 'Action en attente', inactif: 'Aucune action en attente' }"
        :is-readonly="true"
      />
      <BasicCell
        :span="4"
        extra-class="elem--clickable"
      >
        <span @click="displayFacture(item.code)">{{ item?.reference }}</span>
      </BasicCell>
      <BasicCell :span="5">{{ dateTimeToReadableDate(item?.dateEmission) }}</BasicCell>
      <BasicCell :span="5">{{ dateTimeToReadableDate(item?.dateReception) }}</BasicCell>
      <BasicCell
        :span="6"
        extra-class="elem--nowrap"
      >
        {{ item?.etablissementEmetteur?.denomination }}
      </BasicCell>
      <BasicCell
        :span="3"
        extra-class="elem--nowrap"
      >
        <span>{{ `${formatNumber(item?.montantHt, { decimal: 2, separateur: true })} €` }}</span>
      </BasicCell>
      <BasicCell
        :span="3"
        extra-class="elem--nowrap"
      >
        <span>{{ `${formatNumber(item?.montantTTC, { decimal: 2, separateur: true })} €` }}</span>
      </BasicCell>
      <BasicCell :span="8">
        <BasicTooltip :label="StatutFactureLibelle[itemStatut] ?? itemStatut">
          <BasicBadge
            :type="StatutFactureBadgeType[itemStatut] ?? 'info'"
            size="medium"
            :deletable="false"
            :label="StatutFactureLibelle[itemStatut] ?? itemStatut"
          />
        </BasicTooltip>
      </BasicCell>
      <BasicCellActionIcon
        :span="1"
        icon-name="eye"
        :hover-messages="{ actif: 'Consulter la facture' }"
        @click="() => displayFacture(item.code)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { FactureDTO } from '@/features/api/extranet/dto/Facture/FactureDTO'
  import { dateTimeToReadableDate } from '@/features/shared/tools/date'
  import {
    type StatutFactureDTO,
    StatutFactureLibelle,
    StatutFactureBadgeType,
  } from '@/features/api/extranet/dto/Facture/StatutFactureDTO'
  import { formatNumber } from '@/features/shared/tools'
  import { useRechercheFactureActions } from '../useRechercheFactureActions'
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'
  import BasicCellActionIcon from '@designSystem/components/basic/cell/BasicCellActionIcon.vue'

  const props = defineProps<{ item: FactureDTO }>()

  const { displayFacture } = useRechercheFactureActions()

  const itemStatut = computed<StatutFactureDTO>(() => {
    if (props.item?.statut) {
      return props.item?.statut as StatutFactureDTO
    }
    return 'Transmis'
  })
</script>

<style scoped>
  @import '../../index.less';
</style>
